import * as React from "react";
import { ThemeToggle } from "@/components/theme-toggle";

interface ActivityHeaderProps {
  eyebrow?: string;
  title: string;
  connected?: boolean;
}

export default function ActivityHeader({
  eyebrow = "Integration",
  title,
  connected = true,
}: ActivityHeaderProps) {
  return (
    <header className="sticky top-0 z-30 border-b border-border/60 bg-shell/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-3xl items-center justify-between gap-4 px-4 py-4 sm:px-6">
        <div className="flex flex-col">
          <span className="text-[0.68rem] font-semibold uppercase tracking-[0.24em] text-muted-foreground">
            {eyebrow}
          </span>
          <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">
            {title}
          </h1>
        </div>
        <div className="flex items-center gap-3">
          <span
            aria-label={connected ? "Connected" : "Disconnected"}
            title={connected ? "Connected" : "Disconnected"}
            className={
              connected
                ? "hidden sm:inline-flex h-2 w-2 rounded-full bg-primary shadow-[0_0_24px_hsl(var(--primary)/0.8)]"
                : "hidden sm:inline-flex h-2 w-2 rounded-full bg-destructive shadow-[0_0_24px_hsl(var(--destructive)/0.8)]"
            }
          />
          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
